import { StyledLink } from "orcs-design-system";

import { personDetailsPath } from "src/util/routing";

/** Name in a sentence. Same person page as PersonLink / history. No id → text. */
export const PersonNameLink = ({
  name,
  personId,
}: {
  name: string;
  personId?: string | null | undefined;
}) => {
  const id = personId?.trim() ?? "";
  if (id === "") {
    return name;
  }
  return (
    <StyledLink
      to={personDetailsPath({ aggregateId: id })}
      target="_blank"
      rel="noopener noreferrer"
      fontSize="inherit"
    >
      {name}
    </StyledLink>
  );
};
